import React, { useEffect, useState } from 'react';
import api from '../services/api';

const Morosos: React.FC = () => {
  const [morosos, setMorosos] = useState<any[]>([]);
  const [whatsappLinks, setWhatsappLinks] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [enviando, setEnviando] = useState(false);

  const cargar = async () => {
    setLoading(true);
    try {
      setMorosos((await api.get('/facturas/morosos')).data);
    } catch {}
    finally { setLoading(false); }
  };

  const cargarWhatsapp = async () => {
    setEnviando(true);
    try {
      const res = await api.get('/tareas/whatsapp-morosos');
      setWhatsappLinks(res.data);
    } catch {}
    finally { setEnviando(false); }
  };

  useEffect(() => { cargar(); }, []);

  const enviarWhatsApp = (url: string) => window.open(url, '_blank');

  const enviarWhatsAppDirecto = (telefono: string, nombre: string, deuda: number) => {
    const tel = telefono.replace(/[^0-9]/g, '');
    const numero = tel.startsWith('51') ? tel : `51${tel}`;
    const msg = encodeURIComponent(`Estimado/a ${nombre.split(' ')[0]}, tiene una deuda pendiente de S/. ${deuda.toFixed(2)} por el servicio de agua. Por favor regularice su pago para evitar el corte. Gracias.`);
    window.open(`https://wa.me/${numero}?text=${msg}`, '_blank');
  };

  const totalDeuda = morosos.reduce((s, c) => s + c.deudaTotal, 0);

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <h2 style={{ color:'#f1f5f9', margin:0, fontSize:24, fontWeight:800 }}>&#9888;&#65039; Morosos</h2>
          <p style={{ color:'#64748b', margin:'4px 0 0', fontSize:13 }}>Clientes con facturas vencidas sin pagar</p>
        </div>
        <div style={{ display:'flex', gap:10 }}>
          <button onClick={async () => {
            try {
              const res = await api.get('/reportes/morosos/excel', { responseType: 'blob' });
              const href = URL.createObjectURL(res.data);
              const a = document.createElement('a');
              a.href = href;
              a.download = `morosos-${new Date().toISOString().split('T')[0]}.xlsx`;
              a.click();
              URL.revokeObjectURL(href);
            } catch { alert('Error al generar Excel'); }
          }} style={{ background:'#0f172a', border:'1px solid #334155', color:'#94a3b8', padding:'8px 14px', borderRadius:8, cursor:'pointer', fontWeight:600, fontSize:12 }}>
            ⬇ Excel Morosos
          </button>
          <button onClick={() => {
            const rows = [
              ['Cliente','DNI','Telefono','Plan','Meses deuda','Deuda total'],
              ...morosos.map((c:any) => [`${c.nombres} ${c.apellidos}`, c.dni||'', c.telefono||'', c.paquete?.nombre||'', c.mesesDeuda, c.deudaTotal.toFixed(2)])
            ];
            const csv = '﻿' + rows.map(r => r.map(x => `"${String(x).replace(/"/g,'""')}"`).join(',')).join('\n');
            const blob = new Blob([csv], { type:'text/csv;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a'); a.href=url; a.download=`morosos-${new Date().toISOString().split('T')[0]}.csv`; a.click();
            URL.revokeObjectURL(url);
          }} style={{ background:'#0f172a', border:'1px solid #334155', color:'#94a3b8', padding:'8px 14px', borderRadius:8, cursor:'pointer', fontWeight:600, fontSize:12 }}>
            📥 CSV
          </button>
          <button onClick={cargarWhatsapp} disabled={enviando}
            style={{ background:'#25d366', border:'none', color:'white', padding:'10px 16px', borderRadius:8, cursor:'pointer', fontWeight:700, fontSize:13 }}>
            {enviando ? 'Cargando...' : '📱 WhatsApp masivo'}
          </button>
          <button onClick={cargar} style={{ background:'#1e293b', border:'1px solid #334155', color:'#94a3b8', padding:'8px 16px', borderRadius:8, cursor:'pointer' }}>
            🔄 Actualizar
          </button>
        </div>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:20 }}>
        {[
          { label:'Total morosos', value: morosos.length, color:'#ef4444' },
          { label:'Deuda total', value: `S/. ${totalDeuda.toFixed(2)}`, color:'#f59e0b' },
          { label:'Promedio deuda', value: morosos.length > 0 ? `S/. ${(totalDeuda/morosos.length).toFixed(2)}` : 'S/. 0.00', color:'#a78bfa' },
        ].map(s => (
          <div key={s.label} style={{ background:'#1e293b', borderRadius:10, padding:'14px 18px', border:`1px solid ${s.color}33` }}>
            <div style={{ color:'#64748b', fontSize:12 }}>{s.label}</div>
            <div style={{ color:s.color, fontSize:22, fontWeight:800 }}>{s.value}</div>
          </div>
        ))}
      </div>

      {/* WhatsApp masivo */}
      {whatsappLinks.length > 0 && (
        <div style={{ background:'#1e293b', borderRadius:12, border:'1px solid #25d36633', padding:16, marginBottom:20 }}>
          <div style={{ color:'#25d366', fontWeight:700, fontSize:15, marginBottom:12 }}>&#128241; Mensajes WhatsApp listos — {whatsappLinks.length} clientes</div>
          <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
            {whatsappLinks.map((w: any) => (
              <button key={w.clienteId} onClick={() => enviarWhatsApp(w.whatsappUrl)}
                style={{ background:'#25d36622', border:'1px solid #25d36644', color:'#25d366', borderRadius:8, padding:'8px 14px', cursor:'pointer', fontSize:13, fontWeight:600 }}>
                &#128241; {w.nombre.split(' ')[0]} — S/. {w.deudaTotal.toFixed(2)}
              </button>
            ))}
          </div>
        </div>
      )}

      {loading ? <div style={{ color:'#64748b', textAlign:'center', padding:48 }}>Cargando...</div> :
        <div style={{ background:'#1e293b', borderRadius:12, overflow:'hidden', border:'1px solid #334155' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr style={{ background:'#0f172a' }}>
                {['Cliente','Telefono','Plan','Meses deuda','Deuda total','Acciones'].map(h => (
                  <th key={h} style={{ padding:'12px 16px', color:'#64748b', fontSize:12, fontWeight:600, textAlign:'left', borderBottom:'1px solid #334155' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {morosos.map((c, i) => (
                <tr key={c.id} style={{ borderBottom:'1px solid #0f172a', background: i % 2 === 0 ? 'transparent' : '#0f172a11' }}>
                  <td style={{ padding:'12px 16px' }}>
                    <div style={{ color:'#f1f5f9', fontWeight:600 }}>{c.nombres} {c.apellidos}</div>
                    <div style={{ color:'#64748b', fontSize:11 }}>{c.direccion || '—'}</div>
                  </td>
                  <td style={{ padding:'12px 16px', color:'#94a3b8', fontSize:13 }}>{c.telefono || '—'}</td>
                  <td style={{ padding:'12px 16px' }}>
                    <span style={{ background:'#0ea5e922', color:'#38bdf8', border:'1px solid #0ea5e944', borderRadius:20, padding:'3px 10px', fontSize:12 }}>
                      {c.paquete?.nombre || '—'}
                    </span>
                  </td>
                  <td style={{ padding:'12px 16px' }}>
                    <span style={{ background:'#ef444422', color:'#ef4444', border:'1px solid #ef444444', borderRadius:20, padding:'3px 10px', fontSize:12, fontWeight:700 }}>
                      {c.mesesDeuda} mes{c.mesesDeuda !== 1 ? 'es' : ''}
                    </span>
                  </td>
                  <td style={{ padding:'12px 16px', color:'#ef4444', fontWeight:700, fontSize:15 }}>S/. {c.deudaTotal.toFixed(2)}</td>
                  <td style={{ padding:'12px 16px' }}>
                    {c.telefono && (
                      <button onClick={() => enviarWhatsAppDirecto(c.telefono, `${c.nombres} ${c.apellidos}`, c.deudaTotal)}
                        style={{ background:'#25d36622', border:'1px solid #25d36644', color:'#25d366', borderRadius:6, padding:'6px 10px', cursor:'pointer', fontSize:12, fontWeight:600 }}>
                        &#128241; WhatsApp
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {morosos.length === 0 && <div style={{ textAlign:'center', color:'#64748b', padding:32 }}>Sin morosos &#127881;</div>}
        </div>
      }
    </div>
  );
};

export default Morosos;